import NotifyAllParticipants from './NotifyAllParticipants';
import UsersAttendeesField from './UsersAttendeesField';
import VideocallField from './VideocallField';

export const getAgendaCustomFields = (props) => {
    switch (props.field.id) {
        case 'usersAttendees':
            return <UsersAttendeesField key={props.field.id} {...props} />;
        case 'notifyAllParticipants':
            return <NotifyAllParticipants key={props.field.id} {...props} />;
        case 'videocall':
        default:
            return <VideocallField key={props.field.id} {...props} />;
    }
};
